import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { ApiUrl } from "../../../ApiUrl";

const ChangePassword = () => {
  const navigate = useNavigate();
  const username = sessionStorage.getItem("username") || "admin";
  const userId = sessionStorage.getItem("userId");

  // Input states
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Visibility states
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!userId) {
      alert("User session not found. Please log in again.");
      return;
    }

    if (!currentPassword || !newPassword || !confirmPassword) {
      alert("Please fill in all fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      alert("New Password and Confirm Password do not match.");
      return;
    }

    if (currentPassword === newPassword) {
      alert("Old password and new password may not be the same.");
      return;
    }

    try {
      setSaving(true);
      const response = await fetch(`${ApiUrl.apiurl}RegisterEmployee/changepassword/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: parseInt(userId, 10),
          old_password: currentPassword,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }),
      });

      const data = await response.json();

      if (response.ok && data.message === "Password changed successfully") {
        alert("Password changed successfully!");
        handleClear();
      } else {
        alert(data.message || "Failed to change password.");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const handleClear = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  const handleClose = () => {
    navigate("/admin/dashboard");
  };

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                CHANGE PASSWORD
              </p>

              {/* Action Buttons Row */}
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12  d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSave}
                    disabled={saving}
                  >
                    {saving ? "Saving..." : "Save"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                    disabled={saving}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2 "
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </div>

              {/* Form Content */}
              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="col-12 col-md-8 col-lg-7">
                    {/* Username Field */}
                    <div className="row mb-3 align-items-center mt-4">
                      <label className="col-sm-4 col-form-label text-md-end fw-bold">
                        Username <span className="text-danger">*</span>
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="text"
                          className="form-control"
                          value={username}
                          readOnly
                          disabled
                          style={{ backgroundColor: "#ffffff" }}
                        />
                      </div>
                    </div>

                    {/* Current Password Field */}
                    <div className="row mb-3 align-items-center">
                      <label className="col-sm-4 col-form-label text-md-end fw-bold">
                        Current Password <span className="text-danger">*</span>
                      </label>
                      <div className="col-sm-8">
                        <div className="input-group">
                          <input
                            type={showCurrent ? "text" : "password"}
                            className="form-control"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            placeholder="Enter your current password"
                          />
                          <span
                            className="input-group-text"
                            onClick={() => setShowCurrent(!showCurrent)}
                            style={{
                              cursor: "pointer",
                              backgroundColor: "#ffffff",
                            }}
                          >
                            {showCurrent ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* New Password Field */}
                    <div className="row mb-3 align-items-center">
                      <label className="col-sm-4 col-form-label text-md-end fw-bold">
                        New Password <span className="text-danger">*</span>
                      </label>
                      <div className="col-sm-8">
                        <div className="input-group">
                          <input
                            type={showNew ? "text" : "password"}
                            className="form-control"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Enter new password"
                          />
                          <span
                            className="input-group-text"
                            onClick={() => setShowNew(!showNew)}
                            style={{
                              cursor: "pointer",
                              backgroundColor: "#ffffff",
                            }}
                          >
                            {showNew ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Confirm Password Field */}
                    <div className="row mb-3 align-items-center">
                      <label className="col-sm-4 col-form-label text-md-end fw-bold">
                        Confirm Password <span className="text-danger">*</span>
                      </label>
                      <div className="col-sm-8">
                        <div className="input-group">
                          <input
                            type={showConfirm ? "text" : "password"}
                            className="form-control"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm your new password"
                          />
                          <span
                            className="input-group-text"
                            onClick={() => setShowConfirm(!showConfirm)}
                            style={{
                              cursor: "pointer",
                              backgroundColor: "#ffffff",
                            }}
                          >
                            {showConfirm ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
